import DashboardToServer, { 
    LAUNCH_QUESTION, LAUNCH_QUESTION as SOCKET_LAUNCH_QUESTION,
    LAUNCH_TWO_WORDS, LAUNCH_TWO_WORDS as SOCKET_LAUNCH_TWO_WORDS,
    LAUNCH_VOTATION, LAUNCH_VOTATION as SOCKET_LAUNCH_VOTATION,
    LAUNCH_VOTATION_AMAGGIORANZA, LAUNCH_VOTATION_AMAGGIORANZA as SOCKET_LAUNCH_VOTATION_AMAGGIORANZA,
    LAUNCH_SONG, LAUNCH_SONG as SOCKET_LAUNCH_SONG,
    LAUNCH_CHOICE, LAUNCH_CHOICE as SOCKET_LAUNCH_CHOICE,
    LAUNCH_SEVEN_WORDS, LAUNCH_SEVEN_WORDS as SOCKET_LAUNCH_SEVEN_WORDS,
    END_GAME, END_GAME as SOCKET_END_GAME,
    WAIT_TO_END , WAIT_TO_END as SOCKET_WAIT_TO_END,
    TWO_WORDS_ENDED as SOCKET_TWO_WORDS_ENDED,
} from '../../events/DashboardToServer'
import { CHOICED, VOTED, VOTED_AMAGGIORANZA } from '../actions'

export const QUESTION_LAUNCHED = 'QUESTION_LAUNCHED'
export const GAME_ENDED = 'GAME_ENDED'
export const TWO_WORDS_LAUNCHED = 'TWO_WORDS_LAUNCHED'
export const VOTATION_LAUNCHED = 'VOTATION_LAUNCHED'
export const VOTATION_AMAGGIORANZA_LAUNCHED = 'VOTATION_AMAGGIORANZA_LAUNCHED'
export const CHOICE_LAUNCHED = 'CHOICE_LAUNCHED'
export const SONG_LAUNCHED = 'SONG_LAUNCHED'
export const SEVEN_WORDS_LAUNCHED = 'SEVEN_WORDS_LAUNCHED'
export const TIMER_STOPPED = 'TIMER_STOPPED'
export const I_VE_END = 'I_VE_END';
export const TWO_WORDS_ENDED = 'TWO_WORDS_ENDED'

export const game = (state = [], action) => {
    switch (action.type) {
        case QUESTION_LAUNCHED:
            var ss = {
                ...state,
            }
            ss.question = action.question
            ss.gameType = 1
            return ss   
    
        case TWO_WORDS_LAUNCHED:
            var ss = {
                ...state,
            }
            ss.twoWords = action.twoWords
            ss.gameType = 2
            ss.playerNumber = action.playerNumber
            return ss   

        case VOTATION_LAUNCHED:
            var ss = {
                ...state,
            }
            ss.gameType = 3
            return ss   
    
        case VOTATION_AMAGGIORANZA_LAUNCHED:
            var ss = {
                ...state,
            }
            ss.gameType = 9
            return ss   

        case SONG_LAUNCHED:
            var ss = {
                ...state,
            }
            ss.songA = action.song.songA
            ss.songB = action.song.songB
            ss.songC = action.song.songC
            ss.songD = action.song.songD
            ss.rightAnswer = action.song.rightAnswer
            ss.gameType = 4
            return ss   
        
        
        case CHOICE_LAUNCHED:
                var ss = {
                    ...state,
                }
                ss.gameType = 5
                return ss   
    
        case SEVEN_WORDS_LAUNCHED:
            var ss = {
                ...state,
            }
            ss.gameType = 6
            ss.sevenWords = action.sevenWords
            ss.number = action.number
            return ss   
                
        case I_VE_END:
            var ss = {
                ...state,
            }
            if (ss.numberOfEnded == undefined) ss.numberOfEnded=1;
            else ss.numberOfEnded++;
            return ss;

        case TWO_WORDS_ENDED:
            var ss = {
                ...state,
            }
            ss.numberOfEnded =0;
            return ss;
                
        case GAME_ENDED:
            var ss = {
                ...state,
            }
            ss.question = undefined
            ss.gameType = 0
            return ss   

        case CHOICED:
            var ss = {
                ...state,
            }
            ss.question = undefined
            ss.gameType = 0
            return ss   

        case VOTED:
            var ss = {
                ...state,
            }
            ss.question = undefined
            ss.gameType = 0
            return ss   
    
        case VOTED_AMAGGIORANZA:
            var ss = {
                ...state,
            }
            ss.question = undefined
            ss.gameType = 0
            return ss   
    
        default:
            return state
    }
}

export const launchQuestion = (socket) => {
    socket.emit(SOCKET_LAUNCH_QUESTION)
    return { type: LAUNCH_QUESTION}
}

export const questionLaunched = (question) => {
    return { type: QUESTION_LAUNCHED, question:question}
}

export const gameEnded = () =>{
    return {type:GAME_ENDED}
}

export const endGame = ({socket}) =>{
    socket.emit(SOCKET_END_GAME)
    return {type:END_GAME}
}


export const launchTwoWords = (socket) => {
    socket.emit(SOCKET_LAUNCH_TWO_WORDS)
    return { type: LAUNCH_TWO_WORDS}
}

export const twoWordsLaunched = (twoWords, playerNumber) => {
    return { type: TWO_WORDS_LAUNCHED, twoWords:twoWords, playerNumber:playerNumber}
}

export const launchVotation = (socket) => {
    socket.emit(SOCKET_LAUNCH_VOTATION)
    return { type: LAUNCH_VOTATION}
}

export const launchVotationAMaggioranza = (socket) => {
    socket.emit(SOCKET_LAUNCH_VOTATION_AMAGGIORANZA)
    return { type: LAUNCH_VOTATION_AMAGGIORANZA}
}

export const votationLaunched = () => {
    return { type: VOTATION_LAUNCHED}
}

export const votationAMaggioranzaLaunched = () => {
    return { type: VOTATION_AMAGGIORANZA_LAUNCHED}
}


export const launchSong = (socket) => {
    socket.emit(SOCKET_LAUNCH_SONG)
    return { type: LAUNCH_SONG}
}

export const songLaunched = (song) => {
    return { type: SONG_LAUNCHED, song:song}
}

export const launchChoice = (socket) => {
    socket.emit(SOCKET_LAUNCH_CHOICE)
    return { type: LAUNCH_CHOICE}
}

export const choiceLaunched = () => {
    return { type: CHOICE_LAUNCHED}
}

export const launchSevenWords = (socket, improviser) => {
    socket.emit(SOCKET_LAUNCH_SEVEN_WORDS, improviser)
    return { type: LAUNCH_SEVEN_WORDS}
}

export const sevenWordsLaunched = (sevenWords, number) => {
    return { type: SEVEN_WORDS_LAUNCHED, sevenWords:sevenWords, number:number}
}

export const waitToEnd = (socket) =>{
    socket.emit(SOCKET_WAIT_TO_END);
    return  {type:WAIT_TO_END}
}

export const iVeEnd = () =>{
    return {type:I_VE_END}
}

export const onTwoWordsEnded = (socket) =>{
    socket.emit(SOCKET_TWO_WORDS_ENDED);
    return {type:TWO_WORDS_ENDED}
}


// WEBPACK FOOTER //
// ./src/reducers/game/index.js